var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"pending-update",on:{"click":_vm.openModal}},[_c('dash-animated-icon',{staticClass:"spinner",attrs:{"animation-data":_vm.$options.animations.spinner,"loop":"","autoplay":""}}),(!_vm.withoutLabel)?_c('span',[_vm._v(" "+_vm._s(_vm.$t(_vm.labelId))+" ")]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }